export default __webpack_public_path__ + "static/media/drawn-tree-icon.f72548b9.svg";